<template>
    <main id="liste" v-cloak>
        <HeaderTab 
            :title="$t('menu.semence')" 
            :swiper_tabs="swiper_tabs"
        />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">

	export default {
		name: "semence",
		mixins: [],
		data () {
			return {
				swiper_tabs: [{
                        label: 'monte.semence.my_stallions',
                        href : 'semenceStallions',
                        active: true,
                        name: ''
                    },
                    {
                        label: 'monte.semence.my_commandes_non_traitees',
                        href : 'semenceCommandesNonTraitees',
                        active: false,
                        name: ''
                    },
                    {
                        label: 'monte.semence.my_commandes_non_expediees',
                        href : 'semenceCommandesNonExpediees',
                        active: false,
                        name: ''
                    },
                    {
                        label: 'monte.semence.my_expeditions',
                        href : 'semenceExpeditions',
                        active: false,
                        name: ''
                    }
                ]
			}
		},
		components: {
            HeaderTab: () => import('@/components/HeaderTab')
		}
	}
</script>